import { Component, input, ChangeDetectionStrategy } from "@angular/core";
import { Icon } from "../utils/icon/icon";
import { TranslocoModule } from "@jsverse/transloco";

@Component({
  selector: "app-card-result-small",
  imports: [Icon, TranslocoModule],
  templateUrl: "./card-result-small.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./card-result-small.scss"],
})
export class CardResultSmall {
  title = input.required<string>();
  text = input.required<string>();
  image = input<string>();
  link = input.required<string>();
  variant = input<"primary" | "secondary" | "tertiary" | "quaternary">(
    "primary"
  );

  openLinkAndRedirect(): void {
    window.open(this.link(), "_blank");
  }
}
